import { appConfig } from "Config";
import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

// Distributed tracing: propagate trace headers to our own API only (so spans
// link front-to-back) — never to third-party origins. apiUrl is per-env; drop
// it if unset so we don't end up with an empty target that matches everything.
const tracePropagationTargets = ["localhost", appConfig().apiUrl].filter(
  Boolean,
);

Sentry.init({
  dsn: appConfig().sentryDsn,
  ignoreErrors: ["Non-Error promise rejection captured"],
  environment: appConfig().environment,
  release: appConfig().release,
  integrations: [
    // Pairs with Sentry.withSentryReactRouterV7Routing(Routes) in App.tsx to
    // turn navigations into performance transactions.
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  sendDefaultPii: true,
  // Per-environment sample rates (see Config.ts): prod records a small fraction
  // of navigations/errors; dev review-apps run near-zero — Sentry is on there
  // only so the trace-header propagation + CORS path is exercised in CI.
  tracesSampleRate: appConfig().sentryTracesSampleRate,
  sampleRate: appConfig().sentrySampleRate,
  tracePropagationTargets,
});
